import { appSetup } from './core';

/**
 * Sticky header on scroll, plus the two Semantic popups that serve as menus.
 *
 * Both menus close on scroll and resize. That works around a Semantic 2.4 bug
 * where a popup positioned near the viewport edge can end up off-screen
 * (Semantic-Org/Semantic-UI#3004), which the sticky header transition would
 * otherwise expose.
 */

function configureStickyHeader(): void {
  const { header } = appSetup;

  if (!header) {
    return;
  }

  window.addEventListener(
    'scroll',
    () => {
      header.classList.toggle('sticky-header', window.pageYOffset > appSetup.headOffset);
    },
    { passive: true },
  );
}

/**
 * Turns a trigger into a click-opened popup that dismisses itself on scroll past
 * the sticky threshold, or on any resize.
 */
function configurePopupMenu(containerId: string, triggerSelector: string): void {
  const container = document.getElementById(containerId);

  if (!container) {
    return;
  }

  const trigger = window.$(container).find(triggerSelector).first();

  if (trigger.length === 0) {
    return;
  }

  const hide = (): void => {
    trigger.popup('hide');
  };

  const hideWhenStuck = (): void => {
    if (window.pageYOffset > appSetup.headOffset) {
      hide();
    }
  };

  trigger.popup({
    on: 'click',
    position: 'top right',
    setFluidWidth: false,
    lastResort: 'bottom right',
    transition: 'drop',
    duration: 100,
    onVisible: () => {
      window.addEventListener('scroll', hideWhenStuck, { passive: true });
      window.addEventListener('resize', hide);
    },
    onHidden: () => {
      window.removeEventListener('scroll', hideWhenStuck);
      window.removeEventListener('resize', hide);
    },
  });
}

export function initMainHeader(): void {
  configureStickyHeader();
  configurePopupMenu('mobile-nav', '.menu-button');
  configurePopupMenu('main-nav', '#tjenester-link');
}
